import { introduction } from '../../content/introduction';
import { therapyProcess } from '../../content/therapyProcess';
import { credentials } from '../../content/credentials';
import { aboutMe } from '../../content/aboutMe';

// Simplified content accessors
export const intro = {
  problemAwareness: () => introduction.find(s => s.id === 'problem-awareness'),
  lifeTooShort: () => introduction.find(s => s.id === 'life-too-short'),
  changePossible: () => introduction.find(s => s.id === 'change-possible'),
  imagineDifferent: () => introduction.find(s => s.id === 'imagine-different'),
  byId: (id) => introduction.find(s => s.id === id)
};

export const process = {
  typicalResults: () => therapyProcess.sections.find(s => s.id === 'typical-results'),
  assessment: () => therapyProcess.sections.find(s => s.id === 'assessment'),
  analysisPlanning: () => therapyProcess.sections.find(s => s.id === 'analysis-planning'),
  personalizedPath: () => therapyProcess.sections.find(s => s.id === 'personalized-path'),
  assessmentImportance: () => therapyProcess.sections.find(s => s.id === 'assessment-importance'),
  cbtMethodology: () => therapyProcess.sections.find(s => s.id === 'cbt-methodology'),
  rfdIntegration: () => therapyProcess.sections.find(s => s.id === 'rfd-integration'),
  byId: (id) => therapyProcess.sections.find(s => s.id === id),
  title: therapyProcess.title
};

export const creds = {
  education: () => credentials.sections.find(s => s.id === 'education-certifications'),
  publications: () => credentials.sections.find(s => s.id === 'publications'),
  academicProfile: () => credentials.sections.find(s => s.id === 'academic-profile'),
  conferences: () => credentials.sections.find(s => s.id === 'conferences'),
  affiliations: () => credentials.sections.find(s => s.id === 'affiliations'),
  byId: (id) => credentials.sections.find(s => s.id === id),
  title: credentials.title
};

export const about = {
  concreteSolutions: () => aboutMe.differentiators.find(d => d.id === 'concrete-solutions'),
  customTreatment: () => aboutMe.differentiators.find(d => d.id === 'custom-treatment'),
  scientificTechniques: () => aboutMe.differentiators.find(d => d.id === 'scientific-techniques'),
  patientCare: () => aboutMe.differentiators.find(d => d.id === 'patient-care'),
  researchActive: () => aboutMe.differentiators.find(d => d.id === 'research-active'),
  byId: (id) => aboutMe.differentiators.find(d => d.id === id),
  title: aboutMe.title,
  personalIntro: aboutMe.personalIntro
};

// Utility functions for common patterns
export const mapCredentials = (sectionId, renderFn) => {
  const section = creds.byId(sectionId);
  return section?.items?.map(renderFn) || [];
};

export const mapProcess = (sectionId, renderFn) => {
  const section = process.byId(sectionId);
  return section?.items?.map(renderFn) || [];
};

export const mapIntroductions = (renderFn) => {
  return introduction.map(renderFn);
};

export const mapConferences = (renderFn) => {
  return creds.conferences()?.items?.map(renderFn) || [];
};